module.exports = __webpack_public_path__ + "img/lg_ring_g_e_1_null@3x.7886b800.png";